import React from 'react'
import { Checkbox, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import { visibleQuestions } from './surveyQuestions'

// Renders the scale | radio | multi | text question schema from surveyQuestions.js.
export default function QuestionForm ({ questions, answers, onChange }) {
  const set = (id, value) => onChange({ ...answers, [id]: value })

  return (
    <div className="rg-form">
      {visibleQuestions(questions, answers).map(q => (
        <div key={q.id} className="rg-form__q">
          <div className="rg-form__label">
            {q.label}{q.optional && <span className="rg-form__optional"> (optional)</span>}
          </div>
          {(q.type === 'scale' || q.type === 'radio') && (
            <RadioGroup
              row={q.type === 'scale'}
              value={answers[q.id] || ''}
              onChange={e => set(q.id, e.target.value)}
              className={q.type === 'scale' ? 'rg-form__scale' : undefined}
            >
              {q.options.map(opt => (
                <FormControlLabel
                  key={opt}
                  value={opt}
                  control={<Radio size="small" />}
                  label={opt}
                  labelPlacement={q.type === 'scale' ? 'bottom' : 'end'}
                />
              ))}
            </RadioGroup>
          )}
          {q.type === 'multi' && (
            <div className="rg-form__multi">
              {q.options.map((opt) => {
                const selected = Array.isArray(answers[q.id]) ? answers[q.id] : []
                return (
                  <FormControlLabel
                    key={opt}
                    control={(
                      <Checkbox
                        size="small"
                        checked={selected.includes(opt)}
                        onChange={e => set(q.id, e.target.checked ? [...selected, opt] : selected.filter(s => s !== opt))}
                      />
                    )}
                    label={opt}
                  />
                )
              })}
            </div>
          )}
          {q.type === 'text' && (
            <TextField
              fullWidth
              multiline
              minRows={2}
              size="small"
              value={answers[q.id] || ''}
              onChange={e => set(q.id, e.target.value)}
            />
          )}
        </div>
      ))}
    </div>
  )
}
